import React from 'react'
import { Input } from '@driftt/tide'
import { formatDomainName } from './helpers'

import './style.css'

const DriftHelpDomainInput = ({ onChange, value }) => {
  return (
    <div className="drift-help-domain-input-wrapper">
      <div className="drift-help-input-extension-wrapper">
        <Input
          className="drift-help-domain-input"
          label="Help Center Link"
          onChange={onChange}
          value={formatDomainName(value)}
        />
        <span className="drift-help-input-extension">.drift.help</span>
      </div>
      <small>This link will bring people to the homepage of your help center.</small>
    </div>
  )
}

export default DriftHelpDomainInput